import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { VehiclesPage } from "@/features/vehicles/pages/vehicles-page";
import { vehiclesFilterSchema } from "@/features/vehicles/schemas/vehicles-filter-schema";

export const Route = createFileRoute("/_authenticated/fleet/vehicles/")({
	head: () => pageTitle("Vehicles"),
	component: VehiclesPage,
	validateSearch: zodValidator(vehiclesFilterSchema),
});
